// extracted by mini-css-extract-plugin
export default {"card":"PartnerCard_card__TTtbd","cardHeader":"PartnerCard_cardHeader__kkKH9","cardBody":"PartnerCard_cardBody__gcoGl","partnerLink":"PartnerCard_partnerLink__iIJJg"};